@if (view(); as view) {
  <header class="page-header">
    <a class="back" routerLink="/reglages/notifications">‹ Notifications</a>
    <div class="title">
      <h1>{{ view.label }}</h1>
      <span class="event-tag">{{ view.tag }}</span>
    </div>
    @if (view.description) {
      <p>{{ view.description }}.</p>
    }
    @if (!canEdit) {
      <p class="read-only">
        Lecture seule : le réglage se modifie par le directeur général, le directeur RH ou le
        gestionnaire des processus CDT.
      </p>
    }
  </header>

  <section class="panel general-line" aria-labelledby="general-title">
    <div class="general-head">
      <div>
        <h2 id="general-title">Ligne générale</h2>
        <div class="axes">
          <span class="axis any">Toutes sociétés</span>
          <span class="axis any">Tous types de contrat</span>
          @if (view.setting.precision === 'VALIDATION_TYPE') {
            <span class="axis any">Tous échelons</span>
          }
          @if (view.setting.precision === 'DOCUMENT_TAG') {
            <span class="axis any">Tous documents</span>
          }
        </div>
      </div>
      <button
        matButton
        class="edit-line"
        type="button"
        *appHasRole="editorRoles"
        (click)="openLine(view.general ?? null)"
      >
        Modifier
      </button>
    </div>
    <app-designation-chips
      [designations]="view.general?.designations ?? []"
      [emptyLabel]="view.generalEmptyLabel"
    ></app-designation-chips>
    @if (view.general?.cadence; as cadence) {
      <div class="cadence">{{ describeCadence(cadence) }}</div>
    }
  </section>

  <section class="panel" aria-labelledby="particular-title">
    <div class="particular-head">
      <div>
        <h2 id="particular-title">Lignes particulières</h2>
        <p class="hint">
          Toutes les lignes qui s'appliquent à un contrat cumulent leurs destinataires ; aucune n'en
          retire.
        </p>
      </div>
      <button
        matButton="filled"
        class="add-line"
        type="button"
        *appHasRole="editorRoles"
        (click)="openLine(null)"
      >
        <svg lucidePlus aria-hidden="true"></svg>
        Ajouter une ligne
      </button>
    </div>
    @if (view.particulars.length) {
      <div class="lines-table">
        <div class="line-row head" [class.with-precision]="view.setting.precision !== 'NONE'">
          <div></div>
          <div>Société</div>
          <div>Type de contrat</div>
          @if (view.setting.precision === 'VALIDATION_TYPE') {
            <div>Échelon</div>
          }
          @if (view.setting.precision === 'DOCUMENT_TAG') {
            <div>Document</div>
          }
          <div>Destinataires</div>
          <div></div>
        </div>
        @for (line of view.particulars; track line.id; let rank = $index) {
          <div class="line-row" [class.with-precision]="view.setting.precision !== 'NONE'">
            <span class="rank">{{ rank + 1 }}</span>
            <span class="axis" [class.any]="!line.companyId">{{
              line.companyId ? companyName(line.companyId) : 'Toutes'
            }}</span>
            <span class="axis" [class.any]="!line.contractType">{{
              line.contractType ?? 'Tous'
            }}</span>
            @if (view.setting.precision === 'VALIDATION_TYPE') {
              <span class="axis" [class.any]="!line.validationType">
                {{
                  line.validationType ? (line.validationType | validationRequestTypeLabel) : 'Tous'
                }}
              </span>
            }
            @if (view.setting.precision === 'DOCUMENT_TAG') {
              <span class="axis" [class.any]="!line.documentTag">
                {{ line.documentTag ? documentTagLabels[line.documentTag] : 'Tous' }}
              </span>
            }
            <div>
              <app-designation-chips
                [designations]="line.designations"
                emptyLabel="N'ajoute personne"
              ></app-designation-chips>
              @if (line.cadence; as cadence) {
                <div class="cadence">{{ describeCadence(cadence) }}</div>
              }
            </div>
            <button
              matButton
              class="edit-line"
              type="button"
              *appHasRole="editorRoles"
              (click)="openLine(line)"
            >
              Modifier
            </button>
          </div>
        }
      </div>
    } @else {
      <p class="hint empty">
        Aucune ligne particulière : la ligne générale vaut pour tous les contrats.
      </p>
    }
  </section>

  <section class="panel preview">
    <app-notification-preview [setting]="view.setting"></app-notification-preview>
  </section>
}
